import { render, staticRenderFns } from "./cooler-trade.vue?vue&type=template&id=1f5d2cf8&scoped=true"
import script from "./cooler-trade.vue?vue&type=script&lang=js"
export * from "./cooler-trade.vue?vue&type=script&lang=js"
import style0 from "./cooler-trade.vue?vue&type=style&index=0&id=1f5d2cf8&prod&lang=scss&scoped=true"
import style1 from "./cooler-trade.vue?vue&type=style&index=1&id=1f5d2cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7sjryms56nihpddmmbru7sns3m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d2cf8",
  null
  
)

export default component.exports